import { path as notificationsPath } from "./notifications/path";
import { path as createNotificationPath } from "./createNotification/path";
import { path as messagesPath } from "./messages/path";
import { path as createMessagePath } from "./createMessage/path";
import { path as financialReportsPath } from "./financialManagements/financialReports/path";
import { path as guestJoinPath } from "./guestJoin/path";
import { path as chargeWalletPath } from "./chargeWallet/path";
import { path as healthRecordPath } from "./healthRecord/path";
import { path as assignStaffToDoctorPath } from "./assignStaff/path";
import { path as profileDoctorPath } from "./doctorProfile/path";
import { path as commentsPath } from "./comments/path";
import { path as patientsPath } from "./patientManagement/patientsPath";
import { path as myDoctorsPath } from "./myDoctors/path";

import { path as financialPath } from "@routes/financial/path";
import { path as usersPath } from "@routes/userManagement/usersPath";
import { path as hfPath } from "@routes/hf/path";
import { path as testPath } from "@routes/testRoutes/path";
import { path as myPatientsPath } from "@routes/myPatients/path";
import { path as appointmentPath } from "@routes/appointment/path";
import { path as profileManagementPath } from "@routes/profileManagement/path";
import { path as summaryNotePath } from "@routes/summaryNotes/path";
import { path as myFamilyPath } from "@routes/myFamily/path";
import { path as storedResultPath } from "@routes/storedResult/path";
import {
  path as financialRecordsPath,
  path as walletBalancePath,
  path as withdrawPath,
} from "@routes/financialManagements/financialRecords/path";
import { path as pastMedicalHistoryPath } from "@routes/pastMedicalHistory/path";
import { path as availabilityTimePath } from "@routes/availabilityTime/path";
import { path as intakeFormPath } from "@routes/intakeForm/path";
import { path as notificationSettingsPath } from "@routes/notificationSettings/path";
import { path as changePasswordPath } from "@routes/changePassword/path";
import { path as doctorStaffPath } from "@routes/doctorStaff/path";
import { path as patternsPath } from "@routes/patterns/path";
import { path as authManagementPath } from "@routes/authManagement/path";
import { path as reportsPath } from "@routes/reports/path";
import { path as mspPath } from "@routes/msp/path";
import { path as languageSettingPath } from "@routes/languageSettings/path";

export const path = {
  test: testPath,
  hf: hfPath,
  users: usersPath,
  financial: financialPath,
  myPatients: myPatientsPath,
  appointment: appointmentPath,
  profileManagement: profileManagementPath,
  summaryNote: summaryNotePath,
  myFamily: myFamilyPath,
  storedResult: storedResultPath,
  pastMedicalHistory: pastMedicalHistoryPath,
  financialRecords: financialRecordsPath,
  walletBalance: walletBalancePath,
  availabilityTime: availabilityTimePath,
  intakeForm: intakeFormPath,
  notificationSettings: notificationSettingsPath,
  withdrawPath,
  changePassword: changePasswordPath,
  doctorStaff: doctorStaffPath,
  patterns: patternsPath,
  notifications: notificationsPath,
  createNotification: createNotificationPath,
  messages: messagesPath,
  createMessage: createMessagePath,
  financialReports: financialReportsPath,
  guestJoin: guestJoinPath,
  chargeWallet: chargeWalletPath,
  assignStaffToDoctor: assignStaffToDoctorPath,
  healthRecord: healthRecordPath,
  profileDoctor: profileDoctorPath,
  comments: commentsPath,
  patients: patientsPath,
  myDoctors: myDoctorsPath,
  authManagement: authManagementPath,
  reports: reportsPath,
  msp: mspPath,
  languageSetting: languageSettingPath,
};
